var _classCallCheck = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/assertThisInitialized");

var _inherits = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var _require = require('util'),
    inspect = _require.inspect;

var Key = require('./base');

var EmbeddedX5C =
/*#__PURE__*/
function (_Key) {
  "use strict";

  _inherits(EmbeddedX5C, _Key);

  function EmbeddedX5C() {
    var _this;

    _classCallCheck(this, EmbeddedX5C);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(EmbeddedX5C).call(this, {
      type: 'embedded'
    }));
    Object.defineProperties(_assertThisInitialized(_this), {
      kid: {
        value: undefined
      },
      kty: {
        value: undefined
      },
      thumbprint: {
        value: undefined
      },
      toJWK: {
        value: undefined
      },
      toPEM: {
        value: undefined
      }
    });
    return _this;
  }
  /* c8 ignore next 3 */


  _createClass(EmbeddedX5C, [{
    key: inspect.custom,
    value: function value() {
      return 'Embedded.X5C {}';
    }
  }, {
    key: "algorithms",
    value: function algorithms() {
      return new Set();
    }
  }]);

  return EmbeddedX5C;
}(Key);

module.exports = new EmbeddedX5C();